import React, {
    createContext, memo, useContext, useMemo 
} from "react";
import PropTypes from "prop-types";

const OrganisationContext = createContext("global.organisation");

export const OrganisationContextProvider = memo(({ organisation, children }) => {
    return (
        <OrganisationContext.Provider value={organisation}>
            {children}
        </OrganisationContext.Provider>
    );
});

OrganisationContextProvider.defaultProps = {
    children: null,
    organisation: undefined,
};

OrganisationContextProvider.propTypes = {
    children: PropTypes.node,
    organisation: PropTypes.string
};

OrganisationContextProvider.displayName = "OrganisationContextProvider";

export const useOrganisationContext = () => {
    const organisation = useContext(OrganisationContext);
    return useMemo(() => ({ organisation }), [organisation]);
};

export default OrganisationContextProvider;
